module.exports = __webpack_public_path__ + "static/media/supervisorUserGuide.2f1426cc.pdf";